<template>
  <v-container fluid>
    <v-row
      class="rounded elevation-3 white pa-4">
      <v-col
        class="pa-0"
        cols="12">
        <v-btn
          icon
          @click="goBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="6">
        <h4 v-if="warehouse">
          Warehouse : {{ warehouse.name }}
        </h4>
        <h4 v-if="location">
          Location : {{ location.name }}
        </h4>
      </v-col>
      <v-col
        class="text-right"
        md="6"
        cols="12">
        <v-btn
          :disabled="!totalItems"
          class="mr-4"
          color="red"
          @click="showConfirm = true"
        >
          clear location
          <v-icon class="ml-1">
            mdi-bomb
          </v-icon>
        </v-btn>
        <v-btn
          :disabled="!totalItems || loadingExport"
          class="mr-2"
          color="green darken-3"
          :loading="loadingExport"
          @click="exportLocationProduct()">
          EXPORT
          <v-icon class="ml-1">
            mdi-file
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        offset-md="8"
        md="4"
        cols="12"
        class="text-right">
        <search-box
          v-model="search"
          placeholder="Search by code, name"
          @on-search="fetchPaginate(true)" />
      </v-col>
      <v-col cols="12">
        <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item.product.photoUrls="{ item }">
            <div class="d-flex justify-center">
              <img
                width="60px"
                :src="item.product.photoUrls.length ? $convertImgix(`${item.product.photoUrls[0]}?w=128`) : noPicture"
                alt="">
            </div>
          </template>
          <template v-slot:item.sku.color="{ item }">
            <p
              v-if="item.sku"
              class="mb-0">
              {{ item.sku.color.name.toUpperCase() }} - {{ item.sku.size.name.toUpperCase() }}
            </p>
          </template>
          <template v-slot:item.qty="{ item }">
            <p
              v-if="item.sku"
              class="mb-0">
              {{ item.qty | showNumberFormat }}
            </p>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mx-2"
              small
              dark
              color="secondary"
              @click="setAdjustmentData(item, 'adjustment')">
              แก้ไขจำนวน
            </v-btn>
            <v-btn
              class="mx-2"
              small
              dark
              color="indigo"
              @click="setAdjustmentData(item, 'move')">
              ย้าย
            </v-btn>
          </template>
          <template v-slot:no-data>
            <p class="mb-0">
              ไม่พบข้อมูล
            </p>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-pagination
          v-model="query.page"
          color="secondary"
          :total-visible="7"
          :length="totalPages"
          :disabled="loading" />
      </v-col>
    </v-row>
    <adjustment-qty-dialog
      v-if="showDialog"
      :visible.sync="showDialog"
      :adjustment-data="adjustmentData"
      :location="location"
      title="แก้ไขจำนวน"
      @confirm="onAdjustmentConfirm"
      @cancel="onAdjustmentCancel"
    />
    <move-location-dialog
      v-if="showDialogMove"
      :warehouse="query.warehouse"
      :visible.sync="showDialogMove"
      :adjustment-data="adjustmentData"
      :location="location"
      :title="`ย้ายสินค้า ${warehouse.name}`"
      @confirm="onMoveLocationConfirm"
      @cancel="onMoveLocationCancel"
    />
    <re-confirm-dialog
      v-model="showConfirm"
      :loading="clearLoading"
      title="ยืนยันการ Clear Location"
      @confirm="handleClearConfirmed"
      @cancel="showConfirm = false"
    />
  </v-container>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'
import StockLocationProvider from '@/resources/StockLocation.provider'
import SearchBox from '@/components/SearchBox.vue'
import AdjustmentQtyDialog from '../components/AdjustmentQtyDialog.vue'
import MoveLocationDialog from '../components/MoveLocationDialog.vue'
import ReConfirmDialog from '../components/ReConfirmDialog.vue'

const stockLocationService = new StockLocationProvider()

export default {
  components: {
    SearchBox,
    AdjustmentQtyDialog,
    MoveLocationDialog,
    ReConfirmDialog
  },
  data () {
    return {
      loadingAttribute: true,
      loading: false,
      noPicture: NoPicture,
      headers: [
        {
          text: 'photo',
          align: 'center',
          value: 'product.photoUrls',
          sortable: false
        },
        {
          text: 'Name',
          value: 'product.name',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Collection',
          value: 'collectionName',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Code',
          value: 'code',
          sortable: false,
          width: '100px'
        },
        {
          text: 'Color - Size',
          value: 'sku.color',
          sortable: false
        },
        {
          text: 'qty',
          value: 'qty',
          sortable: false,
          align: 'center'
        },
        { text: 'Actions', align: 'center', value: 'actions', sortable: false }
      ],
      items: [],
      totalPages: 0,
      totalItems: 0,
      query: {
        warehouse: null,
        location: null,
        page: 1,
        limit: 10
      },
      search: '',
      location: null,
      warehouse: null,
      showDialog: false,
      showDialogMove: false,
      adjustmentData: null,
      showConfirm: false,
      clearLoading: false,
      loadingExport: false
    }
  },
  computed: {
    warehouses () {
      return this.$store.getters['Store/mapWarehouse']?.filter((v) => v.id !== 0) || []
    }
  },
  watch: {
    query: {
      handler () {
        this.fetchPaginate()
      },
      deep: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.loadingAttribute = true
        if (this.warehouses.length) {
          this.query.warehouse = this.$route.params.warehouse
          this.query.location = this.$route.params.location
          this.warehouse = this.warehouses.find((w) => w.id === +this.$route.params.warehouse)
        }
        this.getLocationById(this.$route.params.location)
        this.fetchPaginate()
      } catch (error) {
        console.error('getAttributes', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loadingAttribute = false
      }
    },
    async fetchPaginate (isClear = false) {
      if (!this.query.warehouse) {
        return
      }

      if (isClear) {
        this.query.page = 1
        this.totalPages = 0
        this.totalItems = 0
      }

      try {
        this.loading = true

        const { data } = await stockLocationService.getMappingLocationPaginate({ ...this.query, search: this.search })

        this.items = data.results
        this.totalPages = data.pages
        this.totalItems = data.total
      } catch (error) {
        console.error('getLocation', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async exportLocationProduct () {
      if (!this.query.warehouse) {
        return
      }

      try {
        this.loadingExport = true
        const { data } = await stockLocationService.exportLocationProduct({ ...this.query, search: this.search })
        this.download(data)
      } catch (error) {
        console.error('getLocation', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loadingExport = false
      }
    },
    download (url, fileName) {
      let tmpFilename = fileName

      if (!fileName) {
        tmpFilename = this.$dayjs().format('YYYYMMDDHHmmss')
      }
      const downloadLink = document.createElement('a')
      downloadLink.href = url
      downloadLink.download = tmpFilename
      downloadLink.click()
    },
    async getLocationById (locationId) {
      try {
        this.loading = true
        const { data } = await stockLocationService.getLocationById(locationId)
        this.location = data
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async onAdjustmentConfirm (qty) {
      try {
        await stockLocationService.setMappingQty({
          warehouse: this.adjustmentData.warehouse.id,
          mappingId: this.adjustmentData.id,
          qty
        })
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'แก้ไขจำนวนสำเร็จ',
          type: 'success'
        })
        this.fetchPaginate()
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      }
      this.adjustmentData = null
      this.showDialog = false
    },
    onAdjustmentCancel () {
      this.adjustmentData = null
      this.showDialog = false
    },
    async onMoveLocationConfirm (payload) {
      try {
        await stockLocationService.moveLocation({
          ...payload,
          warehouse: this.warehouse
        })
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'ย้ายสินค้าสำเร็จ',
          type: 'success'
        })
        this.fetchPaginate()
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      }
      this.adjustmentData = null
      this.showDialogMove = false
    },
    onMoveLocationCancel () {
      this.adjustmentData = null
      this.showDialogMove = false
    },
    setAdjustmentData (val, action) {
      this.adjustmentData = val
      if (action === 'adjustment') {
        this.showDialog = true
      } else {
        this.showDialogMove = true
      }
    },
    goBack () {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'ManageStockLocation', query: { warehouse: this.warehouse } })
      }
    },
    async handleClearConfirmed () {
      this.clearLoading = true
      try {
        await stockLocationService.clearLocation({
          location: this.location.id,
          warehouse: this.warehouse
        })
        this.fetchPaginate(true)
        this.showConfirm = false
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Clear location สำเร็จ',
          type: 'success'
        })
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.clearLoading = false
      }
    }
  }
}
</script>

<style scoped>
img {
  max-height: 80px;
}
</style>
